

  <div class="" [ngClass]="{'p-3 modal-content': (calledFrom == 'slider' || calledFrom == 'BulkAction')}">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-500">Please enter the reason for archive <span class="text-danger">*</span></span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2 mb-3">
      <select data-testid="auto-app-archive-candidate-modal-select-1" class="wc-form-control" name="reasonForArchive" id="reasonToArchiveCandidate" [formControl]="archivereason">
        <option value="null">Select Reason</option>
        <option [value]="archive.archivereasonid" *ngFor="let archive of archivedReasons">{{ archive.reason }}</option>

      </select>
      <p *ngIf="archivereason.errors?.required && (archivereason.dirty || archivereason.touched)"
        class="f-12 text-danger">Reason is required</p>
    </div>
    <div>
      <p class="f-14 mb-2">Reason</p>
      <textarea data-testid="auto-app-archive-candidate-modal-textarea-1" class="wc-form-control" name="reason" placeholder="Enter Reason" id="reason" rows="5" cols="10" style="min-height: 100px;" [formControl]="description"></textarea>
    </div>
    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-archive-candidate-modal-button-1" class="btn-trms-white mr-3" (click)="dismiss()">
          Cancel
        </button>
        <button data-testid="auto-app-archive-candidate-modal-button-2" class="btn-trms-small" (click)="archiveCandidate()">Submit</button>
      </div>
    </div>
  </div>
